import React,{ Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

class NotFoundHelp extends Component {
  render(){
    return (
      <Container>
        <Row>
          <Col xs='12'>
            <br />
            <h1>Not found...</h1>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default NotFoundHelp;



// WEBPACK FOOTER //
// ./src/routes/NotFoundHelp/components/NotFoundHelp.js